import ApiService from "../../../services/ApiService";

async function assertOk(request) {
    const result = await request;
    if (result?.code && result.code !== "SUCCESS") {
        throw new Error(result.message || "Request failed");
    }
    return result;
}

const AdminSlidingPackService = {
    list: async () => {
        const result = await assertOk(ApiService.getData("/v1/puzzle/sliding/pack"));
        return result?.items || [];
    },

    create: async (body) => assertOk(ApiService.postData("/v1/puzzle/sliding/pack", body)),

    update: async (code, body) =>
        assertOk(ApiService.putData(`/v1/puzzle/sliding/pack/${encodeURIComponent(code)}`, body)),

    remove: async (code) =>
        assertOk(ApiService.deleteData(`/v1/puzzle/sliding/pack/${encodeURIComponent(code)}`)),

    levels: async (code, page = 0, pageSize = 25) =>
        assertOk(ApiService.getData(`/v1/puzzle/sliding/pack/${encodeURIComponent(code)}/levels`, { page, pageSize })),

    assignLevels: async (code, storyIds) =>
        assertOk(ApiService.putData(`/v1/puzzle/sliding/pack/${encodeURIComponent(code)}/levels`, { storyIds })),

    fillAutomatically: async (code, language) =>
        assertOk(ApiService.postData(`/v1/puzzle/sliding/pack/${encodeURIComponent(code)}/levels/fill`, {
            language: language || "english",
        })),

    adjustLayouts: async (code, storyIds = []) =>
        assertOk(ApiService.postData(`/v1/puzzle/sliding/pack/${encodeURIComponent(code)}/levels/adjust`, { storyIds })),

    reset: async (code) =>
        assertOk(ApiService.postData(`/v1/puzzle/sliding/pack/${encodeURIComponent(code)}/levels/reset`, {})),

    setFirstLevel: async (code, storyId) =>
        assertOk(ApiService.postData(`/v1/puzzle/sliding/pack/${encodeURIComponent(code)}/levels/first`, {
            storyId,
        })),

    releaseStory: async (code, storyId) =>
        assertOk(ApiService.deleteData(
            `/v1/puzzle/sliding/pack/${encodeURIComponent(code)}/levels/story/${encodeURIComponent(storyId)}`
        )),
};

export default AdminSlidingPackService;
